import { render } from "./card-list.vue?vue&type=template&id=015b7ffd&scoped=true"
import script from "./card-list.vue?vue&type=script&lang=js"
export * from "./card-list.vue?vue&type=script&lang=js"

import "./card-list.vue?vue&type=style&index=0&id=015b7ffd&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015b7ffd"]])

export default __exports__